import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";

// Components
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import Testimonials from "./components/Testimonials";
import Pricing from "./components/Pricing";
import Blog from "./components/Blog";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BookingModal from "./components/BookingModal";
import ScrollToTop from "./components/ScrollToTop";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

const Home = () => {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [services, setServices] = useState([]);
  const [portfolio, setPortfolio] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [pricing, setPricing] = useState([]);
  const [blogPosts, setBlogPosts] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [servicesRes, portfolioRes, testimonialsRes, pricingRes, blogRes] = await Promise.all([
          axios.get(`${API}/services`),
          axios.get(`${API}/portfolio`),
          axios.get(`${API}/testimonials`),
          axios.get(`${API}/pricing`),
          axios.get(`${API}/blog`)
        ]);
        setServices(servicesRes.data);
        setPortfolio(portfolioRes.data);
        setTestimonials(testimonialsRes.data);
        setPricing(pricingRes.data);
        setBlogPosts(blogRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a] noise-overlay" data-testid="home-page">
      <Header onBookClick={() => setIsBookingOpen(true)} />
      <main>
        <Hero onBookClick={() => setIsBookingOpen(true)} />
        <About />
        <Services services={services} />
        <Portfolio portfolio={portfolio} />
        <Testimonials testimonials={testimonials} />
        <Pricing pricing={pricing} onBookClick={() => setIsBookingOpen(true)} />
        <Blog posts={blogPosts} />
        <Contact />
      </main>
      <Footer />
      <BookingModal 
        isOpen={isBookingOpen} 
        onClose={() => setIsBookingOpen(false)} 
        services={services}
      />
      <ScrollToTop />
      <Toaster position="top-right" theme="dark" />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
